import React, { useEffect, useState } from "react";
import { Box, Flex, FormControl, FormLabel, Heading } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import { BlockTypeSelect, BoldItalicUnderlineToggles, CreateLink, headingsPlugin, linkDialogPlugin, linkPlugin, MDXEditor, toolbarPlugin, UndoRedo } from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import './TextContentElement.css';
import Markdown from "react-markdown";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import { useFocus } from "./useFocus";
import { SelectControl } from "./SelectControl";
import rehypeRaw from "rehype-raw";
import { MarkdownLinkDialog } from "../components/MarkdownLinkDialog";
import "../style/mdx.css";
const defaults = {
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
    align: "left"
};
function isText(element) {
    return element.type === "text";
}
export const TextContentElement = (props) => {
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    useEffect(() => {
        if (!isText(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "text", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isText(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Text", attachTo: ref },
                React.createElement(MDXEditor, { markdown: props.contentElement.data.text, plugins: [
                        headingsPlugin(),
                        linkPlugin(),
                        linkDialogPlugin({
                            LinkDialog: MarkdownLinkDialog
                        }),
                        toolbarPlugin({
                            toolbarContents: () => (React.createElement(React.Fragment, null,
                                React.createElement(BlockTypeSelect, null),
                                React.createElement(UndoRedo, null),
                                React.createElement(BoldItalicUnderlineToggles, null),
                                React.createElement(CreateLink, null)))
                        })
                    ], onChange: text => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { text }) })) }),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Text Alignment"),
                    React.createElement(SelectControl, { options: [
                            {
                                value: "left",
                                label: "Left"
                            },
                            {
                                value: "center",
                                label: "Center"
                            },
                            {
                                value: "right",
                                label: "Right"
                            }
                        ], value: props.contentElement.data.align, onChange: (align) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { align: align.value }) })) }))),
        React.createElement(Box, { textAlign: props.contentElement.data.align },
            React.createElement(Markdown, { components: ChakraUIRenderer({
                    h1: (props) => (React.createElement(Heading, { as: "h1" }, props.children)),
                    h2: (props) => (React.createElement(Heading, { as: "h2", size: "h2" }, props.children)),
                    h3: (props) => (React.createElement(Heading, { as: "h3", size: "h3" }, props.children)),
                    h4: (props) => (React.createElement(Heading, { as: "h4", size: "h4" }, props.children)),
                    h5: (props) => (React.createElement(Heading, { as: "h5", size: "h5" }, props.children)),
                    h6: (props) => (React.createElement(Heading, { as: "h6", size: "h6" }, props.children))
                }), rehypePlugins: [rehypeRaw] }, props.contentElement.data.text))));
};
